import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
// import Navbar from './Navbar';
// import FAQAccordion1 from './FAQAccordion1';
// import FAQAccordion2 from './FAQAccordion2';
import "../App.css";
import "./Content.css";
import Container from "@material-ui/core/Container";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import "./TechexpresswayFaqContent.css";
import Data3 from "./Data3.json";
import Data4 from "./Data4.json";
import SearchIcon from "@material-ui/icons/Search";
import { Pagination } from "antd";
import mailData from "../data/mailData.js";

import { useMsal } from "@azure/msal-react";
function TechexpresswayFaqContent() {
  const [click, setClick] = useState(false);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const AdminUsers = [
    "rashi.shrivastava",
    "reshmi.haridas.m",
    "d.d.choudhary",
    "h.srinivasan",
    "varsha.a.tyagi",
    "jeevadharani.ramanan",
    "akash.e.tyagi",
    "lavanya.umesh",
    "aluru.akash",
    "shramika.s.ambolkar",
    "lakshay.c.gupta",
    "aayushi.bharti",
    "uma.rani.battu",
    "akash.e.tyagi",
    "j.b.mittal",
    "b.prasad.mishra",
    "arpita.m.singh"
  ];

  const isAdmin = AdminUsers.includes(loggedInEnterpriseId);
  return (
    <>
      <div className="techexpressway-container main-container" id="faq-box">
        <title>Tech Expressway - FAQs</title>
        <h1 class="sr-only" tabIndex={0}>
          Job Readiness - FAQs
        </h1>
        <img
          src="/images/faqs-banner.jpg"
          className="banner-img"
          alt="faq-banner-image"
          id="main"
        />
        <nav className="navbar">
          <div className="navbar-container">
            <ul className="nav-menu">
              <li className="nav-item">
                <NavLink
                  to="/home"
                  className="nav-links"
                  activeClassName="is-active"
                  exact={true}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/foundation-component"
                  target="_blank"
                  className="nav-links"
                  activeClassName="is-active"
                >
                  Foundation
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/job-readiness"
                  target="_blank"
                  className="nav-links"
                  activeClassName="is-active"
                >
                  Job Readiness
                </NavLink>
              </li>
              <li className="nav-item">
                <a
                  href="https://atci.techleap.accenture.com"
                  className="nav-links"
                  target="_blank"
                >
                  Specialization
                </a>
              </li>
              {/* <li className="nav-item">
                            <NavLink to="/gamification"  className="nav-links" activeClassName="is-active" exact={true}>Gamification</NavLink>
                        </li> */}
              <li className="nav-item">
                <NavLink
                  to="/techexpressway-faq"
                  className="nav-links"
                  activeClassName="is-active"
                  exact={true}
                >
                  FAQs
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/Testimonials"
                  className="nav-links"
                  activeClassName="is-active"
                  exact={true}
                >
                  Testimonials
                </NavLink>
              </li>
              {isAdmin && (
                <li className="nav-item">
                  <NavLink
                    to="/analytics"
                    className="nav-links"
                    activeClassName="is-active"
                    exact={true}
                  >
                    Analytics
                  </NavLink>
                </li>
              )}
            </ul>
          </div>
        </nav>
      </div>
      <Container>
        <SimpleTabs />
      </Container>
    </>
  );
}
export default TechexpresswayFaqContent;

// tabs function component

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function SimpleTabs() {
  const itemsPerPage = 5;
  const [page, setPage] = React.useState(1);
  const [noOfPages] = React.useState(Math.ceil(Data3.length / itemsPerPage));

  const handlePageChange = (page) => {
    setPage(page);
  };

  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchTermFirst("");
    setSearchTermSecond("");
  };
  const [searchTermFirst, setSearchTermFirst] = useState("");
  const [filteredData3, setFilteredData3] = useState([]);
  const [searchTermSecond, setSearchTermSecond] = useState("");
  const [filteredData4, setFilteredData4] = useState([]);

  useEffect(() => {
    setFilteredData3(
      Data3?.filter(
        (post) =>
          post.question
            ?.toLowerCase()
            .includes(searchTermFirst.toLowerCase()) ||
          post.answer?.toLowerCase().includes(searchTermFirst.toLowerCase())
      )
    );
  }, [searchTermFirst, Data3]);

  useEffect(() => {
    setFilteredData4(
      Data4?.filter(
        (post) =>
          post.question
            ?.toLowerCase()
            .includes(searchTermSecond.toLowerCase()) ||
          post.answer?.toLowerCase().includes(searchTermSecond.toLowerCase())
      )
    );
  }, [searchTermSecond, Data4]);

  return (
    <div className={classes.root}>
      {/*  <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label="FAQs for ASEs" {...a11yProps(0)} />
          <Tab label="FAQs for Mentors/SMEs/Supervisors/DU Leads" {...a11yProps(1)} /> 
        </Tabs>
      </AppBar>*/}
      <h2 className="faq-head">Frequently asked questions</h2>
      <TabPanel value={value} index={0}>
        <div className="posts">
          <div className="search-icon">
            <SearchIcon />
            <input
              type="text"
              className="search-input"
              aria-label="Search"
              placeholder="Search..."
              onChange={(event) => {
                setSearchTermFirst(event.target.value);
              }}
            />
          </div>
          {filteredData3.length === 0 ? (
            <h2 className="not-found">No Results Found</h2>
          ) : (
            filteredData3
              .slice((page - 1) * itemsPerPage, page * itemsPerPage)
              .map((post) => {
                return (
                  <div key={post.id} className="post-box">
                    <img
                      src="/images/question-mark.png"
                      className="question-img"
                      alt="question-mark-icon"
                    />
                    <h3> {post.question}</h3>
                    <p>
                      <span>
                        <a
                          href="/home"
                          style={{ textDecoration: "none", color: "black" }}
                        >
                          {post.answerhyper}
                        </a>
                      </span>
                      {post.answer}
                      <span>
                        <a
                          href={`mailto:${mailData.lkmasegraduation}`}
                          style={{ textDecoration: "none", color: "black" }}
                        >
                          {post.answer2}
                        </a>
                      </span>
                      <span>
                        <a
                          href={`mailto:${mailData.atcitechexpressway}`}
                          style={{ textDecoration: "none", color: "black" }}
                        >
                          {post.answer3}
                        </a>
                      </span>
                      <span>
                        <a
                          href={`mailto:${mailData.joinertechenable}`}
                          style={{ textDecoration: "none", color: "black" }}
                        >
                          {post.answer4}
                        </a>
                      </span>
                    </p>
                  </div>
                );
              })
          )}
          <div className="pagination-container">
            <Pagination
              // count={noOfPages}
              current={page}
              onChange={handlePageChange}
              // defaultPage={2}
              // color="primary"
              size="large"
              total={noOfPages * 10}
              // showQuickJumper
              locale={{ page: `of ${noOfPages}` }}
              showSizeChanger={false}
              // showFirstButton
              // showLastButton
            />
          </div>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <div className="posts">
          <div className="search-icon">
            <SearchIcon />
            <input
              type="text"
              className="search-input"
              placeholder="Search..."
              onChange={(event) => {
                setSearchTermSecond(event.target.value);
              }}
            />
          </div>
          {filteredData4.length === 0 ? (
            <h2 className="not-found">No Results Found</h2>
          ) : (
            filteredData4
              .slice((page - 1) * itemsPerPage, page * itemsPerPage)
              .map((post) => {
                return (
                  <div key={post.id} className="post-box">
                    <img
                      src="/images/question-mark.png"
                      className="question-img"
                      alt="question-mark-icon"
                    />
                    <h3> {post.question}</h3>
                    <p>
                      {post.answer}
                      <span>{post.answer2}</span>
                      <span>{post.answer3}</span>
                      <span>{post.answer4}</span>
                      <span style={{ paddingLeft: "20px" }}>
                        {post.answer5}
                      </span>
                      <span style={{ paddingLeft: "20px" }}>
                        {post.answer6}
                      </span>
                      <span style={{ paddingLeft: "20px" }}>
                        {post.answer7}
                      </span>
                      <a href={`mailto:${mailData.atciprofessionaladv}`}>
                        {post.mailLink1}
                      </a>
                      <a href={`mailto:${mailData.lkmtechleapsupport}`}>
                        {post.mailLink2}
                      </a>
                      <a href={`mailto:${mailData.atcitechleapexams}`}>
                        {post.mailLink3}
                      </a>
                      <a href={`mailto:${mailData.atcitechexpressway}`}>
                        {post.mailLink4}
                      </a>
                      <a href={post.hyperlink1} target="_blank">
                        {post.hyperlink1}
                      </a>{" "}
                      <a href={post.hyperlink2} target="_blank">
                        {post.hyperlink2}
                      </a>
                    </p>
                  </div>
                );
              })
          )}
          <div className="pagination-container">
            <Pagination
              // count={noOfPages}
              current={page}
              onChange={handlePageChange}
              // defaultPage={2}
              // color="primary"
              size="large"
              total={noOfPages * 10}
              // showQuickJumper
              locale={{ page: `of ${noOfPages}` }}
              showSizeChanger={false}
              // showFirstButton
              // showLastButton
            />
          </div>
        </div>
      </TabPanel>
    </div>
  );
}
